export const AIRSPACE_API_HOST = import.meta.env.VITE_AIRSPACE_API_URL;

export const WEATHER_PATH = '/api/airspace/weather';

// 30 nm is the backend default and matches the ASOS station density in most of CONUS.
// Smaller radius risks empty responses in sparse areas; larger adds upstream cost.
export const DEFAULT_RADIUS_NM = 30;

export const JSON_HEADERS = { 'Content-Type': 'application/json' };
